// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CarritoRouteImport } from './routes/carrito'
import { Route as ClientesRouteImport } from './routes/clientes'
import { Route as ContactoRouteImport } from './routes/contacto'
import { Route as CursosRouteImport } from './routes/cursos'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as HomeRouteImport } from './routes/home'
import { Route as PreguntasFrecuentesRouteImport } from './routes/preguntas-frecuentes'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated.admin'
import { Route as AliadosBukRouteImport } from './routes/aliados.buk'
import { Route as ClientesIndexRouteImport } from './routes/clientes.index'
import { Route as ClientesCasosExitoRouteImport } from './routes/clientes.casos-exito'
import { Route as ComunicacionesMediaRouteImport } from './routes/comunicaciones.media'
import { Route as ComunicacionesRecursosRouteImport } from './routes/comunicaciones.recursos'
import { Route as ContactoIndexRouteImport } from './routes/contacto.index'
import { Route as ContactoFormularioRouteImport } from './routes/contacto.formulario'
import { Route as ContactoReunionRouteImport } from './routes/contacto.reunion'
import { Route as CursosEmpresasRouteImport } from './routes/cursos.empresas'
import { Route as CursosPersonasRouteImport } from './routes/cursos.personas'
import { Route as GuiasAcreditacionCodelcoRouteImport } from './routes/guias.acreditacion-codelco'
import { Route as LegalPoliticaCookiesRouteImport } from './routes/legal.politica-cookies'
import { Route as LegalPoliticaPrivacidadRouteImport } from './routes/legal.politica-privacidad'
import { Route as LegalSeguridadInformacionRouteImport } from './routes/legal.seguridad-informacion'
import { Route as LegalTerminosCondicionesRouteImport } from './routes/legal.terminos-condiciones'
import { Route as QuienesSomosAlianzasRouteImport } from './routes/quienes-somos.alianzas'
import { Route as QuienesSomosCorfoCreaValidaRouteImport } from './routes/quienes-somos.corfo-crea-valida'
import { Route as QuienesSomosEquipoRouteImport } from './routes/quienes-somos.equipo'
import { Route as QuienesSomosQueEsRouteImport } from './routes/quienes-somos.que-es'
import { Route as SolucionesAcreditacionContratistasRouteImport } from './routes/soluciones.acreditacion-contratistas'
import { Route as SolucionesTecnologiaAprendizajeRouteImport } from './routes/soluciones.tecnologia-aprendizaje'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated.admin.index'
import { Route as AuthenticatedAdminChatbotRouteImport } from './routes/_authenticated.admin.chatbot'
import { Route as AuthenticatedAdminContenidosRouteImport } from './routes/_authenticated.admin.contenidos'
import { Route as AuthenticatedAdminCursosRouteImport } from './routes/_authenticated.admin.cursos'
import { Route as AuthenticatedAdminEditorialesRouteImport } from './routes/_authenticated.admin.editoriales'
import { Route as AuthenticatedAdminEquipoRouteImport } from './routes/_authenticated.admin.equipo'
import { Route as AuthenticatedAdminFormulariosRouteImport } from './routes/_authenticated.admin.formularios'
import { Route as AuthenticatedAdminHeroRouteImport } from './routes/_authenticated.admin.hero'
import { Route as AuthenticatedAdminLeadsRouteImport } from './routes/_authenticated.admin.leads'
import { Route as AuthenticatedAdminLinkedinRouteImport } from './routes/_authenticated.admin.linkedin'
import { Route as AuthenticatedAdminMediaRouteImport } from './routes/_authenticated.admin.media'
import { Route as AuthenticatedAdminNewsletterRouteImport } from './routes/_authenticated.admin.newsletter'
import { Route as AuthenticatedAdminNoticiasRouteImport } from './routes/_authenticated.admin.noticias'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated.admin.settings'
import { Route as ComunicacionesEditorialesIndexRouteImport } from './routes/comunicaciones.editoriales.index'
import { Route as ComunicacionesEditorialesSlugRouteImport } from './routes/comunicaciones.editoriales.$slug'
import { Route as ComunicacionesEventosMineTalentRouteImport } from './routes/comunicaciones.eventos.mine-talent'
import { Route as ComunicacionesEventosVRadiografiaRouteImport } from './routes/comunicaciones.eventos.v-radiografia'
import { Route as ComunicacionesNewsletterIndexRouteImport } from './routes/comunicaciones.newsletter.index'
import { Route as ComunicacionesNewsletterIdRouteImport } from './routes/comunicaciones.newsletter.$id'
import { Route as ComunicacionesNoticiasIndexRouteImport } from './routes/comunicaciones.noticias.index'
import { Route as ComunicacionesNoticiasSlugRouteImport } from './routes/comunicaciones.noticias.$slug'
import { Route as ComunicacionesPodcastIndexRouteImport } from './routes/comunicaciones.podcast.index'
import { Route as ComunicacionesPodcastIdRouteImport } from './routes/comunicaciones.podcast.$id'
import { Route as CursosEmpresasIndexRouteImport } from './routes/cursos.empresas.index'
import { Route as CursosEmpresasBukRouteImport } from './routes/cursos.empresas.buk'
import { Route as CursosEmpresasConstruccionRouteImport } from './routes/cursos.empresas.construccion'
import { Route as CursosEmpresasEnergiaRouteImport } from './routes/cursos.empresas.energia'
import { Route as CursosEmpresasIndustriaRouteImport } from './routes/cursos.empresas.industria'
import { Route as CursosEmpresasMineriaRouteImport } from './routes/cursos.empresas.mineria'
import { Route as CursosEmpresasProgramasAMedidaRouteImport } from './routes/cursos.empresas.programas-a-medida'
import { Route as CursosPersonasIndexRouteImport } from './routes/cursos.personas.index'
import { Route as CursosPersonasCertificacionMineClassRouteImport } from './routes/cursos.personas.certificacion-mine-class'
import { Route as CursosPersonasConvenioUmayorRouteImport } from './routes/cursos.personas.convenio-umayor'
import { Route as CursosPersonasSenceRouteImport } from './routes/cursos.personas.sence'
import { Route as SolucionesAcreditacionContratistasIndexRouteImport } from './routes/soluciones.acreditacion-contratistas.index'
import { Route as SolucionesAcreditacionContratistasExamineRouteImport } from './routes/soluciones.acreditacion-contratistas.examine'
import { Route as SolucionesAcreditacionContratistasMinePassRouteImport } from './routes/soluciones.acreditacion-contratistas.mine-pass'
import { Route as SolucionesTecnologiaAprendizajeIndexRouteImport } from './routes/soluciones.tecnologia-aprendizaje.index'
import { Route as SolucionesTecnologiaAprendizajeAthenaLmsRouteImport } from './routes/soluciones.tecnologia-aprendizaje.athena-lms'
import { Route as SolucionesTecnologiaAprendizajeFaceIdRouteImport } from './routes/soluciones.tecnologia-aprendizaje.face-id'
import { Route as SolucionesTecnologiaAprendizajeSoniaRouteImport } from './routes/soluciones.tecnologia-aprendizaje.sonia'
import { Route as SolucionesTecnologiaAprendizajeVigiaRouteImport } from './routes/soluciones.tecnologia-aprendizaje.vigia'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CarritoRoute = CarritoRouteImport.update({
            id: '/carrito',path: '/carrito',getParentRoute: () => rootRouteImport
          })
const ClientesRoute = ClientesRouteImport.update({
            id: '/clientes',path: '/clientes',getParentRoute: () => rootRouteImport
          })
const ContactoRoute = ContactoRouteImport.update({
            id: '/contacto',path: '/contacto',getParentRoute: () => rootRouteImport
          })
const CursosRoute = CursosRouteImport.update({
            id: '/cursos',path: '/cursos',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const HomeRoute = HomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => rootRouteImport
          })
const PreguntasFrecuentesRoute = PreguntasFrecuentesRouteImport.update({
            id: '/preguntas-frecuentes',path: '/preguntas-frecuentes',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AliadosBukRoute = AliadosBukRouteImport.update({
            id: '/aliados/buk',path: '/aliados/buk',getParentRoute: () => rootRouteImport
          })
const ClientesIndexRoute = ClientesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ClientesRoute
          })
const ClientesCasosExitoRoute = ClientesCasosExitoRouteImport.update({
            id: '/casos-exito',path: '/casos-exito',getParentRoute: () => ClientesRoute
          })
const ComunicacionesMediaRoute = ComunicacionesMediaRouteImport.update({
            id: '/comunicaciones/media',path: '/comunicaciones/media',getParentRoute: () => rootRouteImport
          })
const ComunicacionesRecursosRoute = ComunicacionesRecursosRouteImport.update({
            id: '/comunicaciones/recursos',path: '/comunicaciones/recursos',getParentRoute: () => rootRouteImport
          })
const ContactoIndexRoute = ContactoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ContactoRoute
          })
const ContactoFormularioRoute = ContactoFormularioRouteImport.update({
            id: '/formulario',path: '/formulario',getParentRoute: () => ContactoRoute
          })
const ContactoReunionRoute = ContactoReunionRouteImport.update({
            id: '/reunion',path: '/reunion',getParentRoute: () => ContactoRoute
          })
const CursosEmpresasRoute = CursosEmpresasRouteImport.update({
            id: '/empresas',path: '/empresas',getParentRoute: () => CursosRoute
          })
const CursosPersonasRoute = CursosPersonasRouteImport.update({
            id: '/personas',path: '/personas',getParentRoute: () => CursosRoute
          })
const GuiasAcreditacionCodelcoRoute = GuiasAcreditacionCodelcoRouteImport.update({
            id: '/guias/acreditacion-codelco',path: '/guias/acreditacion-codelco',getParentRoute: () => rootRouteImport
          })
const LegalPoliticaCookiesRoute = LegalPoliticaCookiesRouteImport.update({
            id: '/legal/politica-cookies',path: '/legal/politica-cookies',getParentRoute: () => rootRouteImport
          })
const LegalPoliticaPrivacidadRoute = LegalPoliticaPrivacidadRouteImport.update({
            id: '/legal/politica-privacidad',path: '/legal/politica-privacidad',getParentRoute: () => rootRouteImport
          })
const LegalSeguridadInformacionRoute = LegalSeguridadInformacionRouteImport.update({
            id: '/legal/seguridad-informacion',path: '/legal/seguridad-informacion',getParentRoute: () => rootRouteImport
          })
const LegalTerminosCondicionesRoute = LegalTerminosCondicionesRouteImport.update({
            id: '/legal/terminos-condiciones',path: '/legal/terminos-condiciones',getParentRoute: () => rootRouteImport
          })
const QuienesSomosAlianzasRoute = QuienesSomosAlianzasRouteImport.update({
            id: '/quienes-somos/alianzas',path: '/quienes-somos/alianzas',getParentRoute: () => rootRouteImport
          })
const QuienesSomosCorfoCreaValidaRoute = QuienesSomosCorfoCreaValidaRouteImport.update({
            id: '/quienes-somos/corfo-crea-valida',path: '/quienes-somos/corfo-crea-valida',getParentRoute: () => rootRouteImport
          })
const QuienesSomosEquipoRoute = QuienesSomosEquipoRouteImport.update({
            id: '/quienes-somos/equipo',path: '/quienes-somos/equipo',getParentRoute: () => rootRouteImport
          })
const QuienesSomosQueEsRoute = QuienesSomosQueEsRouteImport.update({
            id: '/quienes-somos/que-es',path: '/quienes-somos/que-es',getParentRoute: () => rootRouteImport
          })
const SolucionesAcreditacionContratistasRoute = SolucionesAcreditacionContratistasRouteImport.update({
            id: '/soluciones/acreditacion-contratistas',path: '/soluciones/acreditacion-contratistas',getParentRoute: () => rootRouteImport
          })
const SolucionesTecnologiaAprendizajeRoute = SolucionesTecnologiaAprendizajeRouteImport.update({
            id: '/soluciones/tecnologia-aprendizaje',path: '/soluciones/tecnologia-aprendizaje',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminChatbotRoute = AuthenticatedAdminChatbotRouteImport.update({
            id: '/chatbot',path: '/chatbot',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContenidosRoute = AuthenticatedAdminContenidosRouteImport.update({
            id: '/contenidos',path: '/contenidos',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCursosRoute = AuthenticatedAdminCursosRouteImport.update({
            id: '/cursos',path: '/cursos',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEditorialesRoute = AuthenticatedAdminEditorialesRouteImport.update({
            id: '/editoriales',path: '/editoriales',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEquipoRoute = AuthenticatedAdminEquipoRouteImport.update({
            id: '/equipo',path: '/equipo',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFormulariosRoute = AuthenticatedAdminFormulariosRouteImport.update({
            id: '/formularios',path: '/formularios',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminHeroRoute = AuthenticatedAdminHeroRouteImport.update({
            id: '/hero',path: '/hero',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLeadsRoute = AuthenticatedAdminLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLinkedinRoute = AuthenticatedAdminLinkedinRouteImport.update({
            id: '/linkedin',path: '/linkedin',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminMediaRoute = AuthenticatedAdminMediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminNewsletterRoute = AuthenticatedAdminNewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminNoticiasRoute = AuthenticatedAdminNoticiasRouteImport.update({
            id: '/noticias',path: '/noticias',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminRoute
          })
const ComunicacionesEditorialesIndexRoute = ComunicacionesEditorialesIndexRouteImport.update({
            id: '/comunicaciones/editoriales/',path: '/comunicaciones/editoriales/',getParentRoute: () => rootRouteImport
          })
const ComunicacionesEditorialesSlugRoute = ComunicacionesEditorialesSlugRouteImport.update({
            id: '/comunicaciones/editoriales/$slug',path: '/comunicaciones/editoriales/$slug',getParentRoute: () => rootRouteImport
          })
const ComunicacionesEventosMineTalentRoute = ComunicacionesEventosMineTalentRouteImport.update({
            id: '/comunicaciones/eventos/mine-talent',path: '/comunicaciones/eventos/mine-talent',getParentRoute: () => rootRouteImport
          })
const ComunicacionesEventosVRadiografiaRoute = ComunicacionesEventosVRadiografiaRouteImport.update({
            id: '/comunicaciones/eventos/v-radiografia',path: '/comunicaciones/eventos/v-radiografia',getParentRoute: () => rootRouteImport
          })
const ComunicacionesNewsletterIndexRoute = ComunicacionesNewsletterIndexRouteImport.update({
            id: '/comunicaciones/newsletter/',path: '/comunicaciones/newsletter/',getParentRoute: () => rootRouteImport
          })
const ComunicacionesNewsletterIdRoute = ComunicacionesNewsletterIdRouteImport.update({
            id: '/comunicaciones/newsletter/$id',path: '/comunicaciones/newsletter/$id',getParentRoute: () => rootRouteImport
          })
const ComunicacionesNoticiasIndexRoute = ComunicacionesNoticiasIndexRouteImport.update({
            id: '/comunicaciones/noticias/',path: '/comunicaciones/noticias/',getParentRoute: () => rootRouteImport
          })
const ComunicacionesNoticiasSlugRoute = ComunicacionesNoticiasSlugRouteImport.update({
            id: '/comunicaciones/noticias/$slug',path: '/comunicaciones/noticias/$slug',getParentRoute: () => rootRouteImport
          })
const ComunicacionesPodcastIndexRoute = ComunicacionesPodcastIndexRouteImport.update({
            id: '/comunicaciones/podcast/',path: '/comunicaciones/podcast/',getParentRoute: () => rootRouteImport
          })
const ComunicacionesPodcastIdRoute = ComunicacionesPodcastIdRouteImport.update({
            id: '/comunicaciones/podcast/$id',path: '/comunicaciones/podcast/$id',getParentRoute: () => rootRouteImport
          })
const CursosEmpresasIndexRoute = CursosEmpresasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CursosEmpresasRoute
          })
const CursosEmpresasBukRoute = CursosEmpresasBukRouteImport.update({
            id: '/buk',path: '/buk',getParentRoute: () => CursosEmpresasRoute
          })
const CursosEmpresasConstruccionRoute = CursosEmpresasConstruccionRouteImport.update({
            id: '/construccion',path: '/construccion',getParentRoute: () => CursosEmpresasRoute
          })
const CursosEmpresasEnergiaRoute = CursosEmpresasEnergiaRouteImport.update({
            id: '/energia',path: '/energia',getParentRoute: () => CursosEmpresasRoute
          })
const CursosEmpresasIndustriaRoute = CursosEmpresasIndustriaRouteImport.update({
            id: '/industria',path: '/industria',getParentRoute: () => CursosEmpresasRoute
          })
const CursosEmpresasMineriaRoute = CursosEmpresasMineriaRouteImport.update({
            id: '/mineria',path: '/mineria',getParentRoute: () => CursosEmpresasRoute
          })
const CursosEmpresasProgramasAMedidaRoute = CursosEmpresasProgramasAMedidaRouteImport.update({
            id: '/programas-a-medida',path: '/programas-a-medida',getParentRoute: () => CursosEmpresasRoute
          })
const CursosPersonasIndexRoute = CursosPersonasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CursosPersonasRoute
          })
const CursosPersonasCertificacionMineClassRoute = CursosPersonasCertificacionMineClassRouteImport.update({
            id: '/certificacion-mine-class',path: '/certificacion-mine-class',getParentRoute: () => CursosPersonasRoute
          })
const CursosPersonasConvenioUmayorRoute = CursosPersonasConvenioUmayorRouteImport.update({
            id: '/convenio-umayor',path: '/convenio-umayor',getParentRoute: () => CursosPersonasRoute
          })
const CursosPersonasSenceRoute = CursosPersonasSenceRouteImport.update({
            id: '/sence',path: '/sence',getParentRoute: () => CursosPersonasRoute
          })
const SolucionesAcreditacionContratistasIndexRoute = SolucionesAcreditacionContratistasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SolucionesAcreditacionContratistasRoute
          })
const SolucionesAcreditacionContratistasExamineRoute = SolucionesAcreditacionContratistasExamineRouteImport.update({
            id: '/examine',path: '/examine',getParentRoute: () => SolucionesAcreditacionContratistasRoute
          })
const SolucionesAcreditacionContratistasMinePassRoute = SolucionesAcreditacionContratistasMinePassRouteImport.update({
            id: '/mine-pass',path: '/mine-pass',getParentRoute: () => SolucionesAcreditacionContratistasRoute
          })
const SolucionesTecnologiaAprendizajeIndexRoute = SolucionesTecnologiaAprendizajeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SolucionesTecnologiaAprendizajeRoute
          })
const SolucionesTecnologiaAprendizajeAthenaLmsRoute = SolucionesTecnologiaAprendizajeAthenaLmsRouteImport.update({
            id: '/athena-lms',path: '/athena-lms',getParentRoute: () => SolucionesTecnologiaAprendizajeRoute
          })
const SolucionesTecnologiaAprendizajeFaceIdRoute = SolucionesTecnologiaAprendizajeFaceIdRouteImport.update({
            id: '/face-id',path: '/face-id',getParentRoute: () => SolucionesTecnologiaAprendizajeRoute
          })
const SolucionesTecnologiaAprendizajeSoniaRoute = SolucionesTecnologiaAprendizajeSoniaRouteImport.update({
            id: '/sonia',path: '/sonia',getParentRoute: () => SolucionesTecnologiaAprendizajeRoute
          })
const SolucionesTecnologiaAprendizajeVigiaRoute = SolucionesTecnologiaAprendizajeVigiaRouteImport.update({
            id: '/vigia',path: '/vigia',getParentRoute: () => SolucionesTecnologiaAprendizajeRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminChatbotRoute: AuthenticatedAdminChatbotRoute,AuthenticatedAdminContenidosRoute: AuthenticatedAdminContenidosRoute,AuthenticatedAdminCursosRoute: AuthenticatedAdminCursosRoute,AuthenticatedAdminEditorialesRoute: AuthenticatedAdminEditorialesRoute,AuthenticatedAdminEquipoRoute: AuthenticatedAdminEquipoRoute,AuthenticatedAdminFormulariosRoute: AuthenticatedAdminFormulariosRoute,AuthenticatedAdminHeroRoute: AuthenticatedAdminHeroRoute,AuthenticatedAdminLeadsRoute: AuthenticatedAdminLeadsRoute,AuthenticatedAdminLinkedinRoute: AuthenticatedAdminLinkedinRoute,AuthenticatedAdminMediaRoute: AuthenticatedAdminMediaRoute,AuthenticatedAdminNewsletterRoute: AuthenticatedAdminNewsletterRoute,AuthenticatedAdminNoticiasRoute: AuthenticatedAdminNoticiasRoute,AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const ClientesRouteChildren = {
  ClientesCasosExitoRoute: ClientesCasosExitoRoute,ClientesIndexRoute: ClientesIndexRoute
}

const ClientesRouteWithChildren = ClientesRoute._addFileChildren(ClientesRouteChildren)




const ContactoRouteChildren = {
  ContactoFormularioRoute: ContactoFormularioRoute,ContactoReunionRoute: ContactoReunionRoute,ContactoIndexRoute: ContactoIndexRoute
}

const ContactoRouteWithChildren = ContactoRoute._addFileChildren(ContactoRouteChildren)




const CursosEmpresasRouteChildren = {
  CursosEmpresasBukRoute: CursosEmpresasBukRoute,CursosEmpresasConstruccionRoute: CursosEmpresasConstruccionRoute,CursosEmpresasEnergiaRoute: CursosEmpresasEnergiaRoute,CursosEmpresasIndustriaRoute: CursosEmpresasIndustriaRoute,CursosEmpresasMineriaRoute: CursosEmpresasMineriaRoute,CursosEmpresasProgramasAMedidaRoute: CursosEmpresasProgramasAMedidaRoute,CursosEmpresasIndexRoute: CursosEmpresasIndexRoute
}

const CursosEmpresasRouteWithChildren = CursosEmpresasRoute._addFileChildren(CursosEmpresasRouteChildren)




const CursosPersonasRouteChildren = {
  CursosPersonasCertificacionMineClassRoute: CursosPersonasCertificacionMineClassRoute,CursosPersonasConvenioUmayorRoute: CursosPersonasConvenioUmayorRoute,CursosPersonasSenceRoute: CursosPersonasSenceRoute,CursosPersonasIndexRoute: CursosPersonasIndexRoute
}

const CursosPersonasRouteWithChildren = CursosPersonasRoute._addFileChildren(CursosPersonasRouteChildren)



const CursosRouteChildren = {
  CursosEmpresasRoute: CursosEmpresasRouteWithChildren,CursosPersonasRoute: CursosPersonasRouteWithChildren
}

const CursosRouteWithChildren = CursosRoute._addFileChildren(CursosRouteChildren)




const SolucionesAcreditacionContratistasRouteChildren = {
  SolucionesAcreditacionContratistasExamineRoute: SolucionesAcreditacionContratistasExamineRoute,SolucionesAcreditacionContratistasMinePassRoute: SolucionesAcreditacionContratistasMinePassRoute,SolucionesAcreditacionContratistasIndexRoute: SolucionesAcreditacionContratistasIndexRoute
}

const SolucionesAcreditacionContratistasRouteWithChildren = SolucionesAcreditacionContratistasRoute._addFileChildren(SolucionesAcreditacionContratistasRouteChildren)




const SolucionesTecnologiaAprendizajeRouteChildren = {
  SolucionesTecnologiaAprendizajeAthenaLmsRoute: SolucionesTecnologiaAprendizajeAthenaLmsRoute,SolucionesTecnologiaAprendizajeFaceIdRoute: SolucionesTecnologiaAprendizajeFaceIdRoute,SolucionesTecnologiaAprendizajeSoniaRoute: SolucionesTecnologiaAprendizajeSoniaRoute,SolucionesTecnologiaAprendizajeVigiaRoute: SolucionesTecnologiaAprendizajeVigiaRoute,SolucionesTecnologiaAprendizajeIndexRoute: SolucionesTecnologiaAprendizajeIndexRoute
}

const SolucionesTecnologiaAprendizajeRouteWithChildren = SolucionesTecnologiaAprendizajeRoute._addFileChildren(SolucionesTecnologiaAprendizajeRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AuthRoute: AuthRoute,CarritoRoute: CarritoRoute,ClientesRoute: ClientesRouteWithChildren,ContactoRoute: ContactoRouteWithChildren,CursosRoute: CursosRouteWithChildren,ForgotPasswordRoute: ForgotPasswordRoute,HomeRoute: HomeRoute,PreguntasFrecuentesRoute: PreguntasFrecuentesRoute,ResetPasswordRoute: ResetPasswordRoute,UnsubscribeRoute: UnsubscribeRoute,AliadosBukRoute: AliadosBukRoute,ComunicacionesMediaRoute: ComunicacionesMediaRoute,ComunicacionesRecursosRoute: ComunicacionesRecursosRoute,GuiasAcreditacionCodelcoRoute: GuiasAcreditacionCodelcoRoute,LegalPoliticaCookiesRoute: LegalPoliticaCookiesRoute,LegalPoliticaPrivacidadRoute: LegalPoliticaPrivacidadRoute,LegalSeguridadInformacionRoute: LegalSeguridadInformacionRoute,LegalTerminosCondicionesRoute: LegalTerminosCondicionesRoute,QuienesSomosAlianzasRoute: QuienesSomosAlianzasRoute,QuienesSomosCorfoCreaValidaRoute: QuienesSomosCorfoCreaValidaRoute,QuienesSomosEquipoRoute: QuienesSomosEquipoRoute,QuienesSomosQueEsRoute: QuienesSomosQueEsRoute,SolucionesAcreditacionContratistasRoute: SolucionesAcreditacionContratistasRouteWithChildren,SolucionesTecnologiaAprendizajeRoute: SolucionesTecnologiaAprendizajeRouteWithChildren,ComunicacionesEditorialesSlugRoute: ComunicacionesEditorialesSlugRoute,ComunicacionesEventosMineTalentRoute: ComunicacionesEventosMineTalentRoute,ComunicacionesEventosVRadiografiaRoute: ComunicacionesEventosVRadiografiaRoute,ComunicacionesNewsletterIdRoute: ComunicacionesNewsletterIdRoute,ComunicacionesNoticiasSlugRoute: ComunicacionesNoticiasSlugRoute,ComunicacionesPodcastIdRoute: ComunicacionesPodcastIdRoute,ComunicacionesEditorialesIndexRoute: ComunicacionesEditorialesIndexRoute,ComunicacionesNewsletterIndexRoute: ComunicacionesNewsletterIndexRoute,ComunicacionesNoticiasIndexRoute: ComunicacionesNoticiasIndexRoute,ComunicacionesPodcastIndexRoute: ComunicacionesPodcastIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)